module.exports = __webpack_public_path__ + "images/feature/20160722_1-9dee69bceacdd250b6451e42a879e687.jpg";